import { call, put } from 'redux-saga/effects';

import api from 'api';

import {
    fetchDiscountSubscription,
    fetchDiscountSubscriptionError,
    fetchDiscountSubscriptionSuccess,
} from 'store/subscriptions/actions';

import { handleAuthError } from './utils';

import { normalizeSubscriptionPeriods } from 'helpers/utils';

import { IDiscountSubscription } from 'types/subscription';

export function* getDiscountSubscription({ payload }: ReturnType<typeof fetchDiscountSubscription>) {
    try {
        const discountSubscription: IDiscountSubscription = yield call(
            api.subscriptions.getDiscountSubscription,
            payload
        );

        const [normalizedDiscountSubscription]: IDiscountSubscription[] = yield call(normalizeSubscriptionPeriods, [
            discountSubscription,
        ]);

        yield put(fetchDiscountSubscriptionSuccess(normalizedDiscountSubscription));
    } catch (error) {
        const authErrorWasHandled = yield* handleAuthError(error);

        if (authErrorWasHandled) return;

        yield put(fetchDiscountSubscriptionError());
        console.error(error);
    }
}
